import React, { createContext, useContext, useCallback } from "react";

import { useLazyQuery } from "@apollo/client";

import { GET_ROLES_PERMISSION } from "../../GraphQlCommon/query";
import { LOCAL_STORAGE_ROLES } from "../../Utils/constant";

const PermissionRoleUIContext = createContext();

export function usePermissionRoleUIContext() {
  return useContext(PermissionRoleUIContext);
}

export const PermissionRoleUIConsumer = PermissionRoleUIContext.Consumer;

export function PermissionRoleUIProvider({ children }) {
  const [
    getPermissionRoles,
    { loading, error: rolePermissionError, data: rolePermissionData },
  ] = useLazyQuery(GET_ROLES_PERMISSION, {
    fetchPolicy: "no-cache",
  });

  const setPermissionRoles = useCallback(async () => {
    const roles = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_ROLES));

    if (roles) {
      await getPermissionRoles({
        variables: {
          roles: roles,
        },
      });
      return true;
    } else return false;
  }, []);

  const value = {
    loading,
    rolePermissionData,
    setPermissionRoles,
    rolePermissionError,
  };

  return (
    <PermissionRoleUIContext.Provider value={value}>
      {children}
    </PermissionRoleUIContext.Provider>
  );
}
